import { useTranslation } from 'react-i18next'
import { Search, X } from 'lucide-react'

interface RecipeSearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export function RecipeSearchInput({ value, onChange, placeholder }: RecipeSearchInputProps) {
  const { t } = useTranslation('recipes')

  return (
    <div className="relative print:hidden">
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted pointer-events-none"
        aria-hidden="true"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? t('search.placeholder')}
        aria-label={t('search.ariaLabel')}
        className="w-full min-h-[44px] pl-10 pr-10 py-2 rounded-lg bg-surface text-ink text-sm placeholder:text-muted border border-border focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      />
      {value.length > 0 && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('search.clearSearch')}
          className="absolute right-2 top-1/2 -translate-y-1/2 min-h-[44px] min-w-[44px] flex items-center justify-center"
        >
          <X className="h-4 w-4 text-muted" aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
